<template>
  <div class="row">
    <div class="form-group col-md-12">
      <div class="card">
        <div class="card-header">
          <span >
              {{ $t('project.investment.form.titleDeboursement') }}   
          </span>
          
          <div class="float-right"  v-if="compMode != CRUDMODE.READ">
            <a href="#history" name="history" @click="addInvestmentValue"><span class="fa fa-plus fa-lg"></span></a>
          </div>
        </div>
        <div class="card-body">

            <table id="dataTableEntrepreneurCompany" width="100%" cellspacing="0" 
                class="table table-bordered table-striped dataTable" >
            <thead>
                <tr>
                  <th width="200">{{ $t('project.investment.form.history.typePerson') }}</th>
                  <th >{{ $t('project.investment.form.history.person') }}</th>
                  <th width="150">{{ $t('project.investment.form.history.value') }}</th>
                  <th align=center width="150">{{ $t('project.investment.form.history.lead') }}</th>
                  <th align=center width="200">{{ $t('project.investment.form.history.convention') }}</th>
                  <td width="50"></td> 
                </tr>
              </thead>
              
              <tbody>
                <tr class="odd" v-if="investmentValues.length == 0">
                    <td valign="top" colspan="6" class="dataTables_empty">{{ $t("form.aucun_donne") }}</td>
                </tr>

                <template v-for="(item, index) in investmentValues" v-bind:data-id="item.id"> 
                  <tr>
                    <td> 
                        <select class="form-control" v-model="item.type" @change="f => changeType(f, item)">
                            <option value=1>{{ $t('project.investment.form.history.partner') }}</option>
                            <option value=2>{{ $t('project.investment.form.history.member') }}</option>
                        </select>
                    </td>
                      
                    <td v-if="item.type == 1">
                    
                      <multiselect v-model="item.partner" id="ajax" :custom-label="partnerLabel" 
                        track-by="id" :placeholder="$t('project.investment.form.history.partner')" 
                        open-direction="bottom"
                        :options="partners" :multiple="false" :searchable="true" :loading="isLoading" 
                        :internal-search="false" :clear-on-select="true" :close-on-select="true" 
                        :options-limit="300" :max-height="600" :show-no-results="true" 
                        :hide-selected="true" @search-change="asyncFindPartner"
                        :select-label="$t('multiselect.select-label')">

                        <span slot="noResult">{{ $t('multiselect.not-found') }} </span>
                      </multiselect>

                    </td>
                    
                    <td v-if="item.type == 2">
                      
                      <multiselect v-model="item.member" id="ajax" :custom-label="memberLabel" 
                        track-by="id" :placeholder="$t('project.investment.form.history.member')"
                        open-direction="bottom"
                        :options="members" :multiple="false" :searchable="true" 
                        :options-limit="300" :max-height="600" :show-no-results="true" 
                        @select="f => onMemberSelect(this, f, index)"
                        :select-label="$t('multiselect.select-label')">
                        <!--  @search-change="asyncFindMember" -->

                        <span slot="noResult">{{ $t('multiselect.not-found') }} </span>
                      </multiselect>

                    </td>

                    <td v-if="item.type == undefined">
                      &nbsp;
                    </td>

                    <td>
                      <input v-model.lazy="item.value"
                             @change="getPercentage(item, index)" 
                             name="value" 
                             type="number" 
                             class="form-control" 
                             id="value"  
                      />

                      <div class="same_value" :style="'width: ' + percentages[index] + '%'" ></div> 
                      <label class="legend_value">{{ percentages[index] }} %</label>
                    </td>

                    <td align=center>
                      <label class="custom-control custom-checkbox" style="display: initial !important" v-if="item.type == 2">
                        <input type="checkbox" name="lead"
                          value="1" class="custom-control-input" id="leadInput" v-model="item.lead" >
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-label">Oui</span>
                      </label>
                    </td>

                    <td align=center>
                      <label class="custom-control custom-checkbox" style="display: initial !important"> <!--  v-if="item.type == 2" -->
                        <input type="checkbox" name="conventionVoteAq"
                          value="1" class="custom-control-input" id="conventionVoteAqInput" v-model="item.conventionVoteAq" >
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-label">Oui</span>
                      </label>
                    </td>
                  
                    <td align=center >
                      <a v-if="compMode != CRUDMODE.READ" class="text-danger" v-bind:title="$t('form.delete_button')" href="#InvestmentValue" v-on:click="removeInvestmentValue(index)">
                          <span class="fa fa-lg fa-trash"></span>
                      </a>
                      &nbsp;
                      <a href="#history" name="history" @click="f => showHideDetails(index)">
                        <span class="fa fa-expand fa-lg" v-if="!item.show"></span>
                        <span class="fa fa-compress fa-lg" v-if="item.show"></span>
                      </a>
                    </td> 
                  </tr>
                  <tr v-if="item.show && item.disbursements.length !== 0" v-for="(disbursements, index2) in item.disbursements" :key="Math.pow(10, index2) + index">
           
                    <td colspan=2>
                      &nbsp;
                    </td>
                    <td>
                      <input v-model.trim="disbursements.value" v-money="{}" name="value" 
                          type="text" class="form-control" id="value"  />
                    </td>
                    <td>
                      <moment-date-picker v-model="disbursements.date" :required="false"></moment-date-picker>
                    </td>
                    <td align=center v-if="compMode != CRUDMODE.READ">
                      <a class="text-danger" v-bind:title="$t('form.delete_button')" href="#InvestmentValue" v-on:click="removeDisborsement(item, index2)">
                          <span class="fa fa-lg fa-trash"></span>
                      </a>
                    </td>
                    <td v-else>&nbsp;</td>
                    <td></td>
                  </tr>
                  <tr v-if="item.show && item.disbursements.length === 0 " >
                    <td valign="top" colspan="6" class="dataTables_empty">Aucune donnée disponible dans le tableau</td>
                  </tr>

                  <tr v-if="item.show" class="border_bottom" >
                    <td colspan=2>&nbsp;</td>
                    <td align=center v-if="compMode != CRUDMODE.READ">
                      <a href="#history" name="history" @click="addDisboursement(item)"><span class="fa fa-plus fa-lg"></span></a>
                    </td>
                    <td colspan=4>&nbsp;</td>
                  </tr>
                  
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    PartnerServiceClient,
    MemberServiceClient,
    PartnerDto,
    MemberDto,
    InvestmentValueDto,
    DisbursementDto,
  } from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import CrudMixin from '../../shared/Mixin/CrudMixin'
  import Multiselect from 'vue-multiselect'
  import MomentDatePicker from '../../shared/components/MomentDatePicker'
  import permission from '../../shared/permission'

  export default {
    name: 'InvestmentValue',
    props: {
      investmentValues: {
        type: Array,
        default: function() {
          return []
        },
      },
    },
    data() {
      return {
        members: [],
        partners: [],
        isLoading: false,
        members: [],
        percentages: [],
      }
    },
    mixins: [CrudMixin],
    mounted: function() {
      let self = this

      setTimeout(function() {
        self.fetchData()
        self.setMode()
      }, 1000)
    },
    watch: {
      investmentValues: function(newValue, oldValue) {
        if (oldValue.length == 0 && newValue.length != 0) {
          for (let i = 0; i < newValue.length; i++) {
            this.$set(newValue[i], 'type', newValue[i].partnerId != null ? 1 : 2)
            this.$set(newValue[i], 'show', false)
            if (newValue[i].disbursements.length !== 0) {
              this.getPercentage(newValue[i], i)
            }
          }
        }
      },
    },
    computed: {
      junior: function() {
        return permission.checkPermission(['Pages.Members.Junior.Seulement'])
      },
    },
    methods: {
      onMemberSelect: function(obj, f, index) {
        this.$set(this.investmentValues[index], 'memberType', f.type)
        this.$set(this.investmentValues[index], 'memberStatus', f.status == 2)
      },
      getPercentage: function(item, index) {
        let value = 0
        if (item.value !== 0) {
          value = (
            _.sumBy(item.disbursements, function(o) {
              return parseInt(o.value)
            }) *
            100 /
            parseInt(item.value)
          ).toFixed(2)
        }
        this.percentages[index] = value
        return value
      },
      fetchData: function() {
        let memberService = ServiceFactory.create(MemberServiceClient)

        let getMembers = memberService.getAll(8, '', '', 0, 1000)
        getMembers
          .then(res => {
            this.members = res.items
          })
          .catch(err => err)
      },
      showHideDetails: function(index) {
        this.$set(this.investmentValues[index], 'show', !this.investmentValues[index].show)
      },
      addDisboursement: function(item) {
        let dto = new DisbursementDto()
        dto.init({})
        item.disbursements.push(dto)
      },
      addInvestmentValue: function() {
        let dto = new InvestmentValueDto()
        dto.init({memberStatus: false})
        dto.disbursements = []
        this.investmentValues.push(dto)
      },
      removeInvestmentValue: function(index) {
        this.investmentValues.splice(index, 1)
      },
      removeDisborsement: function(item, index) {
        item.disbursements.splice(index, 1)
      },
      asyncFindPartner: function(query) {
        if (!this.isLoading) {
          this.isLoading = true
  
          let service = ServiceFactory.create(PartnerServiceClient)
          let self = this

          service.getAutoComplet(query).then(response => {
            self.partners = response
            self.isLoading = false
          })
        }
      },

      /*
      asyncFindMember: function(query) {
        if (!this.isLoading) {   
          this.isLoading = true
    
          let service = ServiceFactory.create(MemberServiceClient)
          let self = this

          service.getAutocomplete(query).then(response => {
            let data = response
    
            if (this.junior)
              data = _.filter(data, f => {
                return f.type == 3
              })

            self.members = _.map(data, item => {
              let dto = new MemberDto()
              dto.init(item)
              return dto
            })
            self.isLoading = false
          })
        }
      },*/
      partnerLabel: function(obj) {
        return obj.name
      },
      memberLabel: function(obj) {
        return obj.familyName + ', ' + obj.name
      },
      changeType: function(select, item) {
        if (item.type == 1) {
          item.memberId = null
          item.member = null
        } else {
          item.partner = null
          item.partnerId = null
        }
      },
    },
    components: {
      multiselect: Multiselect,
      'moment-date-picker': MomentDatePicker,
    },
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .day, .dow {
    padding: 0px !important;
  }

  .same_value, .not_same_value{
    padding: 1px 0px;
    float: right;
    margin: 5px 0px 0px 0px;
    border: 1px solid rgba(0, 0, 0, 0.277);
    color:black;
  }

  .same_value {
    background-color: rgba(2, 222, 2, 0.5);
  }

  .legend_value {
    font-size: 12px;
    float: right;
    padding: 0px; margin: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Investment/InvestmentValue.vue